<template>
  <div class="container">
    <div class="animated fadeIn">
      <b-tabs>
        <b-tab title="Maklumat Bank">
        <BankDetails />
        </b-tab>
        <GuarantorDetails others="guarantor1" />
        <div v-if="1==YTPCourseOfferPath">
          <GuarantorDetails others="guarantor2" />
        </div>
      </b-tabs>
      <b-row>
        <b-col sm="12" class="float-right mt-2">
          <b-button
            class="btn btn-lg float-right"
            variant="primary"
            v-confirm="{
              loader: true,
              okText: 'Hantar',
              cancelText: 'Batal',
              ok: okCallback,
              cancel: cancelCallback,
              message: 'Anda tidak boleh mengubah maklumat bank dan penjamin setelah anda menekan butang hantar. Teruskan?'}"
          >
            <i class="fa fa-dot-circle-o"></i> Hantar
          </b-button>
        </b-col>
      </b-row>
    </div>
    <b-modal
      class="app flex-row align-items-center"
      hide-footer
      title="Maklumat Tidak Berjaya dihantar"
      variant="primary"
      header-bg-variant="primary"
      :disabled="Busy === true || Submitted === true"
      v-model="viewError"
    >
      <b-form class="col-md-12">
        <b-row>
          <b-col sm="12">
            <div
              class="alert alert-success"
              role="alert"
              v-if="bankValidation()"
            >✔ Maklumat Bank lengkap.</div>
            <div v-else>
              <div class="alert alert-danger" role="alert">✘ Maklumat Bank tidak lengkap.</div>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="12">
            <div
              class="alert alert-success"
              role="alert"
              v-if="guarantorValidation()"
            >✔ Maklumat Penjamin lengkap.</div>
            <div v-else>
              <div class="alert alert-danger" role="alert">✘ Maklumat Penjamin tidak lengkap.</div>
            </div>
          </b-col>
        </b-row>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import DefaultOption from "./DefaultOption";
import _ from "lodash";
import Vue from "vue";
Vue.use(require("vue-moment"));
Vue.use(require("moment"));
import BankDetails from "./BankDetails";
import GuarantorDetails from "./GuarantorDetails";
import FatherDetails from "./FatherDetails";
import MotherDetails from "./MotherDetails";
import GuardianDetails from "./GuardianDetails";

export default {
  name: "UploadBankAndGuarantorInformation",
  components: {
    DefaultOption,
    BankDetails,
    GuarantorDetails,
    FatherDetails,
    MotherDetails,
    GuardianDetails,
  },
  data: function () {
    return {
      AppId: 0,
      Error: false,
      Message: "",

      ProgrammeName: "",
      Course1Name: "",

      ProgramId: null,
      viewError: null,
      YTPCourseOfferPath: null,

      sCFN: 'UpdateBankAndGuarantorInformation: ',
    };
  },
  async mounted() {
    let isAuth = await this.UserAuth();

    if (isAuth) {
      let generatedResponse = [];
      try {
        generatedResponse.push(this.GetBanks());
      } catch (error) {
        console.log("error" + error);
      }

      await Promise.all(generatedResponse);

      await this.GetPersonalDetails();
      await this.loadOthers('father');
      await this.loadOthers('mother');
      await this.loadOthers('guardian');

      await this.GetIntakes();
      await this.GetProposedStudy();
      //await this.GetStatusHistory();
      await this.GetCountries();
      await this.GetStates();
      await this.GetCities();
    }
  },
  computed: {
    AppBankFormCompleted: {
      get: function() {
        return this.$store.getters["appBankDetails/FormCompleted"];
      }
    },
    Busy: {
      get: function () {
        return this.$store.getters["common/Busy"];
      },
      set: function (value) {
        this.$store.dispatch("common/updateBusy", value);
      },
    },
    Course1Id: {
      get: function () {
        return this.$store.getters["appProposedStudy/Course1"];
      },
      set: function (value) {
        this.$store.dispatch("appProposedStudy/updateCourse1", value);
      },
    },
    FirstName: {
      get: function () {
        return this.$store.getters["appPersonalDetails/FirstName"];
      },
      set: function (value) {
        this.$store.dispatch("appPersonalDetails/updateFirstName", value);
      },
    },
    Guarantor1PersonalDetailsFormCompleted: {
      get: function() {
        return this.$store.getters["guarantor1PersonalDetails/FormCompleted"];
      }
    },
    Guarantor1ContactDetailsFormCompleted: {
      get: function() {
        return this.$store.getters["guarantor1ContactDetails/FormCompleted"];
      }
    },
    Guarantor2PersonalDetailsFormCompleted: {
      get: function() {
        return this.$store.getters["guarantor2PersonalDetails/FormCompleted"];
      }
    },
    Guarantor2ContactDetailsFormCompleted: {
      get: async function() {
        if (true == this.$store.getters["guarantor2ContactDetails/FormCompleted"])
        {
          this.$store.dispatch(
            "guarantor2ContactDetails/updateFormCompleted",
            true
          );
          await this.SaveGuarantor2ContactDetails();
        }
        return this.$store.getters["guarantor2ContactDetails/FormCompleted"];
      }
    },
    IdentityNo: {
      get: function () {
        return this.$store.getters["appPersonalDetails/IdentityNo"];
      },
      set: function (value) {
        this.$store.dispatch("appPersonalDetails/updateIdentityNo", value);
      },
    },
    Intake: {
      get: function () {
        return this.$store.getters["appProposedStudy/Intake"];
      },
      set: function (value) {
        this.$store.dispatch("appProposedStudy/updateIntake", value);
      },
    },
    Submitted: {
      get: function() {
        return this.$store.getters["common/Submitted"];
      },
      set: function(value) {
        this.$store.dispatch("common/updateSubmitted", value);
      }
    },
  },
  methods: {
    bankValidation() {
      let valid = true;
      if (this.AppBankFormCompleted == false) valid = false;
      return valid;
    },
    cancelCallback: function(dialog) {
      dialog.loading(false); // stop the loader (you won't be needing this)
      dialog.close();        // stops loader and close the dialog
      dialog.node.className; // === "btn-danger"
      dialog.data;           // === null
    },
    async GetContactDetails(others) {
      let fN = 'GetContactDetails: ';
      return this.$API
        .get(this.$ContactDetails + "/" + others, { withCredentials: true })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            //this.HTECHLogger(this.sCFN + fN + 'response.data = ' + JSON.stringify(response.data))
            var obj = {};
            obj.Email = response.data.Email;
            obj.FixPhoneNo = response.data.FixPhoneNo;
            obj.MobilePhoneNo = response.data.MobilePhoneNo;
            return obj;
          } else {
            console.log(response.data.detail);
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.status);
          }
        });
    },
    async GetDetails(others) {
      let fN = 'GetDetails: ';
      return this.$API
        .get(this.$PersonalDetails + "/" + others, { withCredentials: true, })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            var obj = {};
            obj.IdentityNo = response.data.IdentityNo;
            obj.FirstName = response.data.FirstName;
            obj.IdentityNoOther = response.data.IdentityNoOther;
            return obj;
          } else {
            console.log(response.data.detail);
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.status);
          }
        });
    },
    async GetHistoryDetails(others) {
      return this.$API
        .get(this.$EmploymentHistory + "/" + others, { withCredentials: true })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            var obj = {};
            obj.MonthlyIncome = response.data.MonthlyIncome;
            return obj;
          } else {
            this.Message = "Sila lengkapkan borang pendaftaran";
            console.log(response.data.detail);
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.status);
          }
        });
    },
    GetIntakes() {
      return this.$API
        .get(this.$IntakeAll, { withCredentials: true })
        .then((response) => {
          this.info = response.data;

          if (response.status == 200 && this.info != null) {
            this.Intakes = this.info;
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.status);
          }
        });
    },
    async GetPersonalAddress(others) {
      let fN = 'GetPersonalAddress: ';
      return this.$API
        .get(this.$PersonalAddress + "/" + others, { withCredentials: true })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            //this.HTECHLogger(this.sCFN + fN + 'response.data = ' + JSON.stringify(response.data))
            var obj = {};
            if (null == response.data.Id) {
              obj.AddressId = 0;
            } else {
              obj.AddressId = response.data.Id;
            }
            obj.Address1 = response.data.Address1;
            obj.Address2 = response.data.Address2;
            obj.Address3 = response.data.Address3;
            obj.Postcode = response.data.Postcode;
            obj.CityId = response.data.CityId;
            obj.StateId = response.data.StateId;
            obj.CountryId = response.data.CountryId;
            obj.CityName = response.data.CityName;
            obj.StateName = response.data.StateName;
            obj.OtherStateName = response.data.OtherStateName;
            obj.CountryName = response.data.CountryName;
            return obj;
          } else {
            var obj = {};
            obj.AddressId = 0;
            return obj;
            console.log(response.data.detail);
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.status);
          }
        });
    },
    GetPersonalDetails() {
      let fN = 'GetPersonalDetails: ';
      return this.$API
        .get(this.$PersonalDetails, { withCredentials: true })
        .then((response) => {
          this.info = response.data;
          if (response.status == 200 && this.info != null) {
            this.HTECHLogger(this.sCFN + fN + 'response.data = ' + JSON.stringify(response.data))
            this.AppId = this.info.AppId;
            this.IdentityNo = this.info.IdentityNo;
            this.FirstName = this.info.FirstName;
          } else {
            this.Message = "Sila lengkapkan borang pendaftaran";
            console.log(this.info.detail);
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.status);
            this.Error = true;
            this.Message = error;
            this.Message = "Sila lengkapkan borang pendaftaran";
          }
        });
    },
    GetProposedStudy() {
      let fN = 'GetProposedStudy: ';
      return this.$API
        .get(this.$ProposedStudy, { withCredentials: true })
        .then((response) => {
          this.info = response.data;
          if (response.status == 200 && response.data != null) {
            this.HTECHLogger(this.sCFN + fN + 'response.data = ' + JSON.stringify(response.data));
            this.Intake = this.info.IntakeId;
            let arr = _.filter(this.Intakes, ["Id", this.Intake]);
            this.ProgrammeId = arr[0].ProgramId;
            this.ProgrammeName = arr[0].Name;
            this.ProgramId = arr[0].ProgramId;
            this.InstituteId = this.info.InstituteId;
            if (this.InstituteId == 0)
              this.InstituteName = this.info.InstituteNameOther;
            else this.InstituteName = this.info.InstituteName;
            console.log(
              (this.InstituteNameOther = this.info.InstituteNameOther)
            );
            this.FieldId = this.info.FieldId;
            if (this.FieldId == 9999) this.FieldName = this.info.FieldNameOther;
            else this.FieldName = this.info.FieldName;
            this.Course1Id = this.info.Course1Id;
            if (this.Course1Id == 9999)
              this.Course1Name = this.info.CourseNameOther;
            else this.Course1Name = this.info.Course1Name;
            this.Course1Code = this.info.Course1Code;
            this.YTPCourseOfferPath = response.data.YTPCourseOfferPath;
          } else {
            console.log(this.info.detail);
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.status);
          }
        });
    },
    GetStatusHistory() {
      return this.$API
        .get(this.$StatusHistory, { withCredentials: true })
        .then((response) => {
          this.info = response.data;

          if (response.status == 200 && this.info != null) {
            this.StatusHistory = this.info;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    guarantorValidation() {
      let valid = true;
      if ((false == this.Guarantor1PersonalDetailsFormCompleted)
      ||  (false == this.Guarantor1ContactDetailsFormCompleted)) {
        valid = false;
      }
      if (1 == this.YTPCourseOfferPath) {
        if ((false == this.Guarantor2PersonalDetailsFormCompleted)
        ||  (false == this.Guarantor2ContactDetailsFormCompleted)) {
          valid = false;
        }
      }
      return valid;
    },
    async insertAppStatus(appId, typeId) {
      const formData = new FormData();
      formData.append("AppId", appId);
      formData.append("TypeId", typeId);
      return this.$API
        .post(this.$InsertAppStatus, formData, { withCredentials: true, })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            console.log("InsertAppStatus");
          }
        });
    },
    async loadOthers(others) {
      let fN = 'loadOthers: ';
      let obj1 = await this.GetDetails(others);
      this.$store.dispatch(others + "PersonalDetails/updateIdentityNo", obj1.IdentityNo);
      this.$store.dispatch(others + "PersonalDetails/updateFirstName", obj1.FirstName);
      this.$store.dispatch(others + "PersonalDetails/updateIdentityNoOther", obj1.IdentityNoOther);
      let obj2 = await this.GetHistoryDetails(others);
      this.$store.dispatch(others + "EmploymentHistory/updateMonthlyIncome", obj2.MonthlyIncome);
      let obj3 = await this.GetContactDetails(others);
      this.$store.dispatch(others + "ContactDetails/updateEmail", obj3.Email);
      this.$store.dispatch(others + "ContactDetails/updateFixPhoneNo", obj3.FixPhoneNo);
      this.$store.dispatch(others + "ContactDetails/updateMobilePhoneNo", obj3.MobilePhoneNo);
      let obj4 = await this.GetPersonalAddress(others);
      this.$store.dispatch(others + "PersonalDetails/updatePersonalAddress", obj4.AddressId);
      this.$store.dispatch(others + "PersonalDetails/updatePersonalAddress1", obj4.Address1);
      this.$store.dispatch(others + "PersonalDetails/updatePersonalAddress2", obj4.Address2);
      this.$store.dispatch(others + "PersonalDetails/updatePersonalAddress3", obj4.Address3);
      this.$store.dispatch(others + "PersonalDetails/updatePersonalPostcode", obj4.Postcode);
      this.$store.dispatch(others + "PersonalDetails/updatePersonalCityId", obj4.CityId);
      this.$store.dispatch(others + "PersonalDetails/updatePersonalStateId", obj4.StateId);
      this.$store.dispatch(others + "PersonalDetails/updatePersonalCountryId", obj4.CountryId);
      this.$store.dispatch(others + "PersonalDetails/updatePersonalCityName", obj4.CityName);
      this.$store.dispatch(others + "PersonalDetails/updatePersonalStateName", obj4.StateName);
      this.$store.dispatch(others + "PersonalDetails/updatePersonalOtherStateName", obj4.OtherStateName);
      this.$store.dispatch(others + "PersonalDetails/updatePersonalCountryName", obj4.CountryName);
    },
    okCallback: async function(dialog) {
      this.Busy = true;
      dialog.loading(false); // stop the loader (you won't be needing this)
      dialog.close();        // stops loader and close the dialog
      dialog.node.className; // === "btn-danger"
      dialog.data;           // === null
      if (
           this.bankValidation()
        && this.guarantorValidation()
         ) {
        await this.SaveBankDetails(),
        await this.SaveGuarantor1PersonalDetails();
        await this.SaveGuarantor1EmploymentHistory();
        await this.SaveGuarantor1ContactDetails();
        await this.SaveGuarantor2PersonalDetails();
        await this.SaveGuarantor2EmploymentHistory();
        await this.SaveGuarantor2ContactDetails();
        await this.insertAppStatus(this.AppId, 11);
        await this.submitBETask(this.AppId, 53);

        this.Busy = false;
        this.$dialog.alert("Maklumat Bank dan Penjamin anda telah dihantar.").then(function() {});
        //this.ReloadPage();
        this.$router.push("/Home");
      } else {
        this.Busy = false;
        this.viewError = true;
      }
    },
    async submitBETask(appId, taskId) {
      const formData = new FormData();
      formData.append("AppId", appId);
      formData.append("TaskId", taskId);
      return this.$API
        .post(this.$InsertBETask, formData, { withCredentials: true })
        .then((response) => {
          if (response.status == 200) {
            console.log("BE Task Saved");
          } else console.log("Error Saving");
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>
